export default __webpack_public_path__ + "static/media/duster-gallery-4.09eab1b3.jpg";